<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
            <slot name="header">
              <div class="card-header fw-bold">
                <span>{{ SectionDetails?.departmentCode }}
                  {{ SectionDetails?.sisCourseId?.substring(0, 8) }} |
                  {{ SectionDetails?.courseName }}
                </span>
              </div>
            </slot>
          </div>
          <div class="modal-body">
            <slot name="body">
              <div class="card-body bCard">
                <form @submit.prevent="AddtoCourse">
                  <div class="row">
                    <div class="col-sm-6 form-group">
                      <label for="Book_Title">
                        <h6>Book Title</h6>
                      </label><span class="text-danger"> * </span>
                      <input required pattern=".*\S+.*" v-model="enteredDetails.Title" placeholder="Type in book name"
                        type="text" name="Title" id="Book_Title" class="form-control" />
                    </div>
                    <div class="col-sm-6 form-group">
                      <label for="Book_id">
                        <h6>ISBN</h6>
                      </label><span class="text-danger"> * </span>
                      <div class="col-sm-12">
                        <div class="row">
                          <div class="col-sm-11">
                            <input required v-model="enteredDetails.BookId" placeholder="Type in Book's ISBN"
                              type="text" name="BookId" id="Book_nId" class="form-control"
                              v-on:keyup="validatingIsbn(enteredDetails.BookId)" />
                          </div>
                          <div class="col-sm-1 mt-1 p-0">
                            <span v-if="!isValidISBN && enteredDetails.BookId !=''"
                              class="text-danger material-icons-outlined" title="Invalid ISBN">cancel</span>
                            <span v-else-if="isValidISBN && enteredDetails.BookId !=''"
                              class="text-primary material-icons-outlined" title="Valid ISBN">check_circle</span>
                          </div>
                        </div>
                     </div>
                      <div class="col-sm-12" v-if="isVisible">
                        <div class="row text-danger">
                          <span>Please enter valid ISBN!!</span>
                        </div>
                      </div>

                    </div>
                    <div class="col-sm-6" v-for="(item, index) in this.enteredDetails.Authors" :key="index">
                      <div class="d-flex">
                        <div class="">
                          <label for="Book_Author">
                            <h6>Author Name</h6>
                          </label>
                          <input v-model="item.Name"
                            placeholder="Type in Author's Name (e.g. First Name Middle Name Last Name)" type="text"
                            name="author" id="author" class="form-control" />
                        </div>
                        <div class="btn-author" v-if="index == this.enteredDetails.Authors.length - 1">
                          <a class="text-primary" @click="AddAuthor">
                            <span class="material-icons-outlined" title="Add an Author">add_circle</span>
                          </a>
                          <a class="text-danger" v-if="this.enteredDetails.Authors.length > 1" @click="removeAuthor">
                            <span class="material-icons" title="Remove an Author">backspace</span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-row row">
                    <div class="col-sm-6 form-group2">
                      <label for="Book_edition">
                        <h6>Edition</h6>
                      </label>
                      <input v-model="enteredDetails.Edition" placeholder="Type book's Edition here(e.g. 13th)"
                        type="text" name="bookEdition" id="Book_Edition" class="form-control" />
                    </div>

                    <div class="col-sm-6 form-group2">
                      <label for="Book_edition">
                        <h6>Publisher</h6>
                      </label>
                      <input v-model="enteredDetails.Publisher" placeholder="Type book's publisher here(e.g. Pearson)"
                        type="text" name="bookPublisher" id="Book_Publisher" class="form-control" />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-7 form-group">
                      <div class="card notes-card">
                        <form>
                          <div class="mb-4">
                            <label for="exampleInputNotes" class="form-label"><b>Notes:</b><i>(Optional)</i></label>
                            <!-- <input type="text" class="form-control" id="exampleInputNotes" aria-describedby="notesHelp"
                              v-model="enteredDetails.Adoption.Notes" /> -->
                              <vue-editor v-model="enteredDetails.Adoption.Notes" :editorToolbar="customToolbar"></vue-editor>
                          </div>
                        </form>
                      </div>
                    </div>
                  
                    <div class="col-sm-5 form-group">
                      <div class="card suggestion-card">
                        <p>This book is:</p>
                        <div class="form-check">
                          <input class="form-check-input" required type="radio" v-model="enteredDetails.Adoption.Suggestion"
                            name="flexRadioDefault" id="flexRadioDefault1" :value=2 />
                          <label class="form-check-label" for="flexRadioDefault1">
                            Required
                          </label>
                        </div>
                        <div class="form-check">
                          <input class="form-check-input" required type="radio" name="flexRadioDefault" id="flexRadioDefault2"
                            v-model="enteredDetails.Adoption.Suggestion" :value=1 />
                          <label class="form-check-label" for="flexRadioDefault2">
                            Recommended
                          </label>
                        </div>
                        <br>
                        <p>Is it recommend to wait to purchase in course?<b>*</b> </p>
                          <div class="form-check">
                            <input class="form-check-input"  type="radio" v-model="enteredDetails.Adoption.isWaitToPurchase"
                              id="isPurchaseYes" :value=true />
                            <label class="form-check-label" for="isPurchaseYes">
                              Yes  
                            </label>
                          </div>

                          <div class="form-check">
                            <input class="form-check-input"  type="radio" id="isPurchaseNo"
                              v-model="enteredDetails.Adoption.isWaitToPurchase" :value=false />
                            <label class="form-check-label" for="isPurchaseNo">
                              No
                            </label>
                          </div>
                          <br>
                          <p id="note">*This option is for those who recommend students wait to purchase Cengage course material within Canvas the first day of class. </p>
                      </div>
                    </div>
                  </div>
                  <button type="button" class="btn btn-outline-danger me-2" @click="$emit('close',false)">
                    <span class="material-icons-outlined btn-icon"> cancel </span>
                    Cancel
                  </button>
                  <button type="submit" class="btn btn-primary me-2">
                    <span class="material-icons-outlined btn-icon"> check_circle </span>
                    Add to Course
                  </button>
                </form>
              </div>
            </slot>
          </div>

        </div>
      </div>
    </div>
  </transition>
</template>

<script>

import {checksum} from 'isbn-validation';
import ISBN from 'isbn-validate';
import { VueEditor } from "vue3-editor";
import * as _ from 'lodash';
export default {
  name: "FacultyHome",
  components:{VueEditor},
  data() {
    return {
      isVisible: false,
      isValidISBN: true,
      bookvalues: {},
      tocheck: 0,
      detailjson: "",
      enteredDetails: {
        BookId: "",
        Title: "",
        Authors: [{ Name: null }],
        Publisher: "",
        Edition: "",
        Adoption: {
          BookId: "",
          Notes: "",
          Suggestion: "",
          isWaitToPurchase: false
        },

      },
      SectionDetails: {
        departmentCode: "",
        courseName: "",
        courseId: "",
        sisCourseId: "",
        sectionId: "",
      },
      customToolbar: [
        [{header: [false,1,2,3,4,5,6]}],
        [{
          align:""
        },
        {
          align:"center"
        },
        {
          align:"right"
        },
        {
          align:"justify"
        }],
        ["bold", "italic", "underline","link"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{indent:"-1"},{indent:"+1"}]
      ],
    
    };
  },
  props: {
    result: Number,
    coursedetails: String,
  },
  methods: {
    AddtoCourse() {
      //const{BookTitle}=Object.fromEntries(new FormData(event.target));
      if (this.isValidISBN && this.enteredDetails.BookId != '') {
        let details = _.cloneDeep(this.enteredDetails);
        details['Authors'] = this.enteredDetails['Authors'].map(x => x.Name);
        details['Adoption'].SectionId = this.coursedetails;
        details['Adoption'].BookId = this.enteredDetails.BookId;
        // details['Adoption'].isWaitForPurchase=this.enteredDetails.Adoption.isWaitToPurchase;
        this.$emit('close', details)
      }
      else {
        this.isVisible = true;
      }
    },
    AddAuthor() {
      //this.$store.dispatch("addNewAuthor");
      this.enteredDetails.Authors.push({ Name: null });
      this.tocheck++;
    },
    removeAuthor() {
      // this.$store.state.newAuthors.splice(-1);
      this.enteredDetails.Authors.splice(-1);
      this.tocheck--;
    },
    validatingIsbn(value) {
      this.isValidISBN = (checksum(value) ||  ISBN.Validate(value));
      this.isVisible = false;
    },
    getSectionDetails() {
      let sectionId = this.coursedetails;
      this.$store.dispatch("getSectionDetailsbyId", sectionId).then((res) => {
        this.SectionDetails = res.data;
      });
    },
  },
  mounted() {
    //this.enteredDetails.Authors = this.$store.state.newAuthors;
    this.getSectionDetails()
  },
};
</script>

<style scoped>
.form-group {
  padding-bottom: 15px;
}

.form-group2 {
  padding-bottom: 15px;
  padding-top: 17px;
}

.form-card {
  padding: 10px;
  margin-top: 30px;
  background-color: #f8fafa;
  width: 60%;
}
.bCard{
  padding-top: 0;
}
.form-values {
  color: #a9b7c6;
  border: 2px solid;
}

.btn-author {
  margin-top: 38px;
  margin-left: 5px;
  cursor: pointer;
}

.suggestion-card {
  margin: 10px 0px 15px 0px;
  padding: 15px;
}

.notes-card {
  margin: 10px 0px 15px 0px;
  padding: 15px;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  overflow-y: auto;
  width: 80%;
  margin: 0px auto;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
  position:fixed;
}

.modal-body {
  margin: 20px 0;
  height: 370px;
  padding-top: 0;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.card-header {
  width: 100%
}

#note{
  font-size: 11px;
  font-weight: bold;
}
</style>